import styled from 'styled-components';
import SVG from 'react-inlinesvg';

export const SvgIconWrapper = styled(SVG)`
  display: block;
  width: 24px;
  height: 24px;
  ${document.documentElement.dir === 'rtl' ? `transform: scaleX(-1);` : ``}
`;
